import { Link } from "react-router-dom";
import { useChristmasTheme } from "@/hooks/useChristmasTheme";

/**
 * Banner compacto "Especial de Navidad" bajo el hero.
 * Decorativo y liviano (sin imágenes pesadas).
 */
export default function ChristmasBanner() {
  const { animations } = useChristmasTheme();

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-700 via-primary-600 to-secondary-700 px-6 py-7 md:px-10 md:py-9">
        {/* brillos decorativos */}
        <div className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 rounded-full bg-accent-400/25 blur-3xl"></div>
        <div className="pointer-events-none absolute -bottom-12 -left-8 h-44 w-44 rounded-full bg-white/10 blur-3xl"></div>

        {/* estrellas flotantes */}
        <span
          aria-hidden="true"
          className={`pointer-events-none absolute right-6 top-4 text-xl text-accent-300 ${
            animations ? "xmas-twinkle" : ""
          }`}
        >
          ✦
        </span>
        <span
          aria-hidden="true"
          className={`pointer-events-none absolute left-8 bottom-4 text-sm text-accent-200 ${
            animations ? "xmas-twinkle" : ""
          }`}
        >
          ✦
        </span>

        <div className="relative z-10 flex flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
          <div className="flex items-center gap-4">
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-3xl ${
                animations ? "xmas-float" : ""
              }`}
            >
              🎁
            </span>
            <div>
              <h2 className="font-heading text-lg font-bold text-white md:text-xl">
                Especial de Navidad
              </h2>
              <p className="mt-1 text-sm text-white/85">
                Descubre productos increíbles y encuentra ese regalo perfecto.
              </p>
            </div>
          </div>
          <Link
            to="/#destacados"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-semibold text-primary-700 transition-transform hover:scale-105 active:scale-95"
          >
            Ver ofertas
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}